import {createSelector} from 'reselect';
import props from '../../../../props';

export default createSelector(
    props.wallet.methods.zelle_deposit,
    (zelle_deposit) => {
        return {
            stage: zelle_deposit.stage
        }
    }
)